import { render, staticRenderFns } from "./ProductPayment.vue?vue&type=template&id=2cf38690"
import script from "./ProductPayment.vue?vue&type=script&lang=js"
export * from "./ProductPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports